import React from "react";

const CardIndividual = ({ image, name, onInfoClick }) => {
  return (
    <div className="group relative overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 border border-gray-300 hover:border-gray-400 rounded-2xl transform transition-all duration-500 hover:scale-105 h-96 w-72 shadow-lg hover:shadow-2xl">
      
      {/* Image Container */}
      <div className="relative h-64 w-full overflow-hidden rounded-t-2xl">
        <img 
          src={image} 
          alt={name || "Vehículo"} 
          className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" 
        />
        
        {/* Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-gray-900/60 via-gray-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
        
        {/* Floating Badge */}
        {/* <div className="absolute top-3 left-3 bg-gradient-to-r from-gray-800 to-gray-900 text-white px-3 py-1 rounded-full text-xs font-bold shadow-lg backdrop-blur-sm border border-gray-600 opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          ✨ Disponible
        </div> */}

        {/* Quick View Icon */}
        <div className="absolute top-3 right-3 w-10 h-10 bg-gradient-to-r from-gray-100 to-white backdrop-blur-sm rounded-full flex items-center justify-center shadow-lg opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-500 border border-gray-300">
          <svg className="w-5 h-5 text-gray-700" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
          </svg>
        </div>
      </div>

      {/* Content Section */}
      <div className="h-32 p-4 bg-gradient-to-b from-gray-50 to-gray-100 flex flex-col justify-center space-y-3">
        {/* Vehicle Name */}
        {name && (
          <h3 className="text-sm font-bold text-gray-800 text-center group-hover:text-gray-900 transition-colors duration-300 truncate">
            {name}
          </h3>
        )}

        {/* Info Button */}
        <button
          onClick={onInfoClick}
          className="w-full py-2 px-4 bg-gradient-to-r from-gray-700 via-gray-800 to-gray-900 text-white font-bold rounded-xl hover:from-gray-800 hover:via-gray-900 hover:to-gray-950 transform hover:scale-105 transition-all duration-300 shadow-lg hover:shadow-xl border border-gray-600 relative overflow-hidden text-sm"
        >
          <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent translate-x-[-100%] group-hover:translate-x-[100%] transition-transform duration-700"></div>
          <span className="relative flex items-center justify-center space-x-2">
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span>Ver Detalles</span>
          </span>
        </button>
      </div>

      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-3 group-hover:opacity-8 transition-opacity duration-500 pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%236b7280' fill-opacity='0.06'%3E%3Ccircle cx='20' cy='20' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>

      {/* Decorative Corner */}
      <div className="absolute bottom-0 left-0 w-16 h-16 bg-gradient-to-tr from-gray-300/20 to-transparent rounded-tr-full opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
      
      {/* Status Indicator */}
      {/* <div className="absolute bottom-1 right-1 w-3 h-3 bg-green-400 rounded-full shadow-sm opacity-0 group-hover:opacity-100 transition-opacity duration-500 animate-pulse"></div> */}
    </div>
  );
};

export default CardIndividual;